{
  "globe": {
    "title": "Your projects",
    "loading": "Loading your projects",
    "placeholder": "Preparing the globe",
    "unavailable": "The globe needs hardware graphics, which this browser has not made available. Your projects are listed below.",
    "pinLabel": "{{name}}, on the globe",
    "flyTo": "Show {{name}} on the globe",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "reset": "Reset view"
  },
  "card": {
    "updated": "Updated {{when}}",
    "noSites": "No sites yet",
    "sites_one": "{{count}} site",
    "sites_other": "{{count}} sites",
    "lastRun": "Last run {{when}}",
    "neverRun": "No runs yet",
    "members_one": "{{count}} member",
    "members_other": "{{count}} members",
    "noLocation": "No location yet",
    "open": "Open {{name}}"
  },
  "visibility": {
    "private": "Private",
    "org": "Organisation",
    "public": "Public"
  },
  "empty": {
    "title": "No projects yet",
    "description": "A project holds the sites you analyse, the runs against them, and everything those produce. Create one to begin.",
    "action": "New project"
  },
  "seeAll": "See all projects",
  "openTools": "Open Tools",
  "newProject": "New project",
  "workspace": {
    "backToProjects": "Projects",
    "layers": "Layers",
    "sites": {
      "version": "v{{version}}",
      "versionHint": "The boundary has been edited. Earlier runs stay bound to the version they ran against.",
      "area": "{{area, number(minimumFractionDigits: 2; maximumFractionDigits: 2)}} ha · {{crs}}",
      "hectares": "{{value, number(minimumFractionDigits: 2; maximumFractionDigits: 2)}} ha",
      "zoomTo": "Zoom to this site",
      "actions": "Actions for {{name}}",
      "rename": "Rename",
      "history": "Boundary history",
      "delete": "Delete",
      "saveBoundary": "Save boundary",
      "saveTitle": "Save this boundary",
      "saveDescription": "The area is measured on the server, in the projection the site will be stored in.",
      "save": "Save site",
      "saveFailed": "The boundary was not saved",
      "saveError": "Something went wrong saving the boundary. Nothing was stored.",
      "rejected": "The server refused this boundary. It may cross itself, or fall outside the allowed size.",
      "measuring": "Measuring on the server…",
      "name": "Name",
      "renameTitle": "Rename site",
      "deleteTitle": "Delete site",
      "deleteConfirm": "Delete “{{name}}” and everything computed against it? This cannot be undone.",
      "historyTitle": "{{name}} — boundary history",
      "historyDescription": "Editing a boundary creates a version. Runs stay bound to the version they ran against.",
      "loadingHistory": "Loading history…",
      "versionColumn": "Version",
      "changedAt": "Changed",
      "current": "current"
    },
    "noSites": "No sites yet",
    "noSitesHint": "Draw a boundary with the polygon or rectangle tool, then save it.",
    "mapPlaceholder": "The map arrives with P1-WEB-05",
    "mapPlaceholderHint": "The workspace chrome is in place. Basemap, draw tools and layers are the next tasks.",
    "openPanel": "Show the side panel",
    "closePanel": "Hide the side panel",
    "runs": "Runs and activity",
    "runsActive": "Runs and activity, {{count}} in progress",
    "runsPlaceholder": "Runs appear here once the runs API lands (P1-PLAT-07).",
    "sections": "Workspace sections",
    "tabs": {
      "search": "Search",
      "imagery": "Imagery",
      "analyse": "Analyse",
      "design": "Design",
      "discrepancy": "Discrepancy",
      "reports": "Reports",
      "chat": "Chat"
    },
    "mapTools": "Map tools",
    "basemap": {
      "label": "Basemap",
      "googleMap": "Google map",
      "googleSatellite": "Google satellite",
      "satellite": "Satellite",
      "streets": "OSM",
      "blank": "Blank",
      "esri": "Esri satellite"
    },
    "coordinates": {
      "position": "{{lat}}, {{lng}}",
      "away": "Move the pointer over the map",
      "computeCrs": "Areas computed in {{crs}}",
      "label": "Pointer position",
      "computeCrsLocal": "Areas computed in each site's state grid"
    },
    "map": {
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "resetBearing": "Reset bearing to north",
      "fullscreen": "Full screen",
      "unavailable": "The map needs hardware graphics, which this browser has not made available."
    },
    "draw": {
      "label": "Draw tools",
      "tools": {
        "select": "Select and edit",
        "polygon": "Draw polygon",
        "rectangle": "Draw rectangle",
        "measure-line": "Measure distance",
        "measure-area": "Measure area"
      },
      "undo": "Undo",
      "redo": "Redo",
      "clear": "Clear all shapes",
      "area": "Area",
      "perimeter": "Perimeter",
      "vertices": "Corners",
      "corners_one": "{{count}} corner",
      "corners_other": "{{count}} corners",
      "overMax": "over the {{max, number}} ha limit",
      "hectares": "{{value, number(minimumFractionDigits: 2; maximumFractionDigits: 2)}} ha",
      "metres": "{{value, number(maximumFractionDigits: 0)}} m",
      "hint": "Click to place each corner. Double-click the last one to finish.",
      "hintRectangle": "Drag a box, or click one corner and then the opposite one.",
      "hintSelect": "Click a shape to edit it. Drag a corner to move it, or a midpoint to add one.",
      "hintMeasureLine": "Click along a route. Double-click the last point to finish.",
      "hintMeasureArea": "Click each corner. Double-click the last one to finish.",
      "preview": "Preview on the WGS84 ellipsoid · saved areas are measured in the site's state grid",
      "computedIn": "Computed in {{crs}}"
    },
    "measure": {
      "title": "Measure",
      "distance": "Distance",
      "area": "Area",
      "distanceUnit": "Distance unit",
      "areaUnit": "Area unit",
      "clear": "Clear all measurements",
      "value": "{{value, number}}",
      "scratch": "Working only — measurements are not saved with the site.",
      "units": {
        "m": "m",
        "km": "km",
        "ft": "ft",
        "m2": "m²",
        "ha": "ha",
        "acre": "acre"
      }
    },
    "shortcuts": {
      "title": "Keyboard shortcuts",
      "description": "Everything the workspace can do from the keyboard.",
      "groups": {
        "tools": "Tools",
        "drawing": "While drawing",
        "panels": "Panels"
      },
      "actions": {
        "select": "Select and edit",
        "polygon": "Draw polygon",
        "rectangle": "Draw rectangle",
        "measure": "Measure distance",
        "cancel": "Cancel the current shape",
        "undo": "Undo",
        "redo": "Redo",
        "layers": "Show or hide the layer panel",
        "help": "Show this list"
      },
      "keys": {
        "shift": "Shift",
        "escape": "Esc"
      },
      "open": "Keyboard shortcuts"
    },
    "snap": {
      "label": "Snap to cadastre",
      "hint": "Snap vertices to nearby gazetted lot boundaries.",
      "pending": "No cadastre is configured. P1-GEO-07 serves the lot boundaries this snaps to."
    },
    "search": {
      "label": "Search a place",
      "placeholder": "Search a place, or paste lat, lng",
      "clear": "Clear",
      "results": "Places found",
      "none": "No place found. Try other words.",
      "failed": "Place search is unavailable right now.",
      "coordinates": "Coordinates",
      "title": "Search",
      "hint": "Type a place in the bar above, or look for what is near the map centre.",
      "recent": "Recent places",
      "rating": "{{rating}} ({{count}})",
      "openNow": "Open now",
      "closedNow": "Closed now",
      "hours": "Opening hours",
      "openInMaps": "Open in Google Maps",
      "nearby": "Nearby",
      "nearbyMap": "Near the map centre",
      "nearbyNone": "Nothing of this kind within 2 km.",
      "categories": {
        "schools": "Schools",
        "health": "Health",
        "worship": "Places of worship",
        "shops": "Shops & markets",
        "transport": "Transport",
        "parks": "Parks"
      }
    },
    "hideLayers": "Hide layers",
    "showLayers": "Show layers"
  },
  "create": {
    "title": "New project",
    "subtitle": "A project holds the sites you analyse and everything they produce.",
    "name": "Project name",
    "description": "Description",
    "descriptionHint": "Optional. What this project covers, for colleagues who open it later.",
    "visibility": "Who can see it",
    "visibilityHint": "Private keeps it to you and anyone you add. This can be changed later.",
    "submit": "Create project",
    "submitting": "Creating",
    "close": "Close",
    "aoiLater": "An initial boundary can be uploaded once the site tools land (P1-PLAT-02).",
    "nameRequired": "Enter a project name"
  },
  "actions": {
    "label": "Actions for {{name}}",
    "open": "Open",
    "rename": "Rename",
    "visibility": "Change who can see it",
    "members": "Manage members",
    "archive": "Archive",
    "unarchive": "Restore from archive",
    "delete": "Delete",
    "duplicateUnavailable": "Duplicate arrives with P1-PLAT-02"
  },
  "rename": {
    "title": "Rename project",
    "submit": "Save"
  },
  "changeVisibility": {
    "title": "Who can see this project",
    "submit": "Save"
  },
  "deleteConfirm": {
    "title": "Delete this project?",
    "description": "It is recoverable for 30 days. Its sites, runs and results go with it and come back with it.",
    "confirm": "Delete project"
  },
  "archived": "Archived",
  "list": {
    "title": "All projects",
    "search": "Search projects",
    "searchPlaceholder": "Search by name",
    "view": "View",
    "viewGrid": "Grid",
    "viewList": "List",
    "cardSize": "Card size",
    "filterVisibility": "Visibility",
    "filterState": "Status",
    "anyVisibility": "Any visibility",
    "state": {
      "active": "Active",
      "archived": "Archived",
      "all": "Active and archived"
    },
    "sort": "Sort by",
    "sortUpdated": "Recently updated",
    "sortCreated": "Recently created",
    "sortName": "Name",
    "count_one": "{{count}} project",
    "count_other": "{{count}} projects",
    "page": "Page {{page}} of {{pages}}",
    "previous": "Previous page",
    "next": "Next page",
    "noMatches": {
      "title": "No projects match",
      "description": "Nothing here fits those filters. Widen them, or clear the search.",
      "clear": "Clear filters"
    },
    "columns": {
      "name": "Project",
      "sites": "Sites",
      "lastRun": "Last run",
      "owner": "Owner",
      "visibility": "Visibility",
      "updated": "Updated",
      "actions": "Actions"
    }
  },
  "design": {
    "eyebrow": "{{site}} / Planning",
    "eyebrowNoSite": "Planning",
    "tabs": {
      "describe": "Proposal",
      "scenarios": "Results"
    },
    "describe": {
      "title": "Explore a proposal",
      "subtitle": "Describe how you want to develop this area.",
      "siteMeta": "{{area}} ha",
      "noSites": "Draw or upload a site on the map to start.",
      "heading": "Describe your proposal",
      "lead": "Set a direction in your own words.",
      "prompt": "Planning prompt",
      "promptHint": "The scenario in words. Change it, or write your own in Bahasa Melayu or English.",
      "promptPlaceholder": "Bangunkan tapak ini sebagai pembangunan bercampur: 20% industri, 30% tanah lapang, 50% kediaman.",
      "reference": "Reference layer",
      "referenceNone": "None",
      "referenceRun": "Land-use analysis · {{site}}",
      "generate": "Generate scenario",
      "generating": "Generating…",
      "failed": "The scenario could not be generated.",
      "scenario": "Scenario",
      "scenarioOwn": "My own description",
      "promptEdited": "Changed: your own description will be used.",
      "capture": "Imagery",
      "noCaptures": "This site has no sub-metre imagery yet. Acquire an Esri or Google capture in the Imagery tab."
    },
    "scenarios": {
      "title": "Results",
      "subtitle": "Review each scenario on the map.",
      "empty": "Generate a scenario first to see it here.",
      "goDescribe": "Back to the proposal",
      "selected": "Concept {{n}} selected. The map is an illustrative allocation overlay, not a generated development plan.",
      "editPrompt": "Edit prompt",
      "reviewConstraints": "Review constraints",
      "constraintsSoon": "Constraint review is coming soon."
    },
    "steps": {
      "label": "Proposal steps",
      "site": "Site",
      "capture": "Capture",
      "scenario": "Scenario"
    }
  },
  "discrepancy": {
    "eyebrow": "{{site}} / Compliance",
    "eyebrowNoSite": "Compliance",
    "title": "Check against the approved plan",
    "subtitle": "Compare what is on the ground with what was approved.",
    "site": "Site",
    "plan": "Approved plan",
    "summary": {
      "total": "Discrepancies",
      "high": "High",
      "medium": "Medium"
    },
    "findings": "Findings",
    "compare": {
      "title": "Approved vs observed",
      "approved": "Approved",
      "observed": "Observed"
    },
    "landUse": {
      "residential": "Residential",
      "openSpace": "Open space",
      "commercial": "Commercial",
      "roads": "Roads"
    },
    "run": "Run check",
    "notConnected": "Checking isn't connected yet — this is a preview with sample findings."
  },
  "chat": {
    "eyebrow": "{{site}} / Assistant",
    "eyebrowNoSite": "Assistant",
    "title": "Ask about this site",
    "subtitle": "Questions about land cover, change and planning, answered from your analyses.",
    "badge": "Preview · sample data",
    "thread": "Conversation",
    "thisSite": "this site",
    "suggestions": "Suggested questions",
    "prompts": {
      "compare": "Compare 2019 and 2025",
      "treeLoss": "Where is tree cover lost?",
      "planningNote": "Draft a planning note"
    },
    "placeholder": "Ask anything — e.g. tree cover lost since 2019?",
    "send": "Send",
    "composer": "Your question",
    "messages": {
      "q1": "Summarise land cover on {{site}}",
      "a1": "In this sample, the land cover of {{site}} looks like this.",
      "q2": "What changed to buildings since 2019?",
      "a2": "Most new buildings replaced bare ground, followed by trees and grass.",
      "notConnected": "Chat isn't connected yet — this is a preview. Your question will be answered here once the assistant is live."
    },
    "stats": {
      "area": "Site area",
      "builtUp": "Built-up",
      "treeCover": "Tree cover",
      "netBuilt": "Net new built-up"
    },
    "donut": {
      "aria": "Land cover: {{parts}}",
      "part": "{{name}} {{share}}%"
    },
    "bars": {
      "title": "Became {{class}} since 2019",
      "ha": "{{value}} ha"
    }
  },
  "dashboard": {
    "breadcrumb": "Dashboard",
    "title": "Land cover over time",
    "site": "Site",
    "sample": "Preview · sample data",
    "sampleNote": "Dates that have not been analysed show sample figures.",
    "loading": "Loading the timeline…",
    "loadFailed": "The timeline could not be loaded.",
    "retry": "Try again",
    "empty": {
      "title": "No imagery yet",
      "body": "Acquire a capture of this site in the workspace's Imagery section, and it will appear here.",
      "action": "Open the workspace"
    },
    "timeline": {
      "label": "Capture dates",
      "analysed": "Analysed",
      "sampled": "Sample figures",
      "marker": "{{date}} · {{kind}}",
      "markerProvider": "{{date}} · {{provider}} · {{kind}}",
      "compare": "Compare two dates",
      "compareNeedsTwo": "Comparing needs two dates.",
      "before": "Before",
      "after": "After"
    },
    "map": {
      "label": "Map",
      "unavailable": "The map is not available in this browser. The figures below are unaffected.",
      "noOverlay": "No land cover overlay on this date: the capture has not been analysed.",
      "noImagery": "This date has no capture to draw; the land cover is shown over the basemap.",
      "failed": "The capture could not be loaded."
    },
    "figures": {
      "title": "Headline figures",
      "on": "{{date}}",
      "between": "{{before}} → {{after}}",
      "sampleOn": "{{date}} · sample figures",
      "sampleDate": "{{date}} (sample)",
      "builtUp": "Built-up",
      "green": "Green cover",
      "water": "Water",
      "bare": "Bare land",
      "buildings": "Buildings",
      "ha": "{{value}} ha",
      "ofSite": "{{value}}% of site",
      "share": "{{value}}%",
      "fromTo": "{{before}} → {{after}} ha",
      "countFromTo": "{{before}} → {{after}}"
    },
    "donut": {
      "title": "Share of the site"
    },
    "trend": {
      "title": "Share of the site over time",
      "note": "Stacked to the whole site. Hollow marks are sample figures; hover for each class, click to open a date.",
      "aria": "{{name}}: {{from}}% on {{first}}, {{to}}% on {{last}}",
      "ha": "{{value}} ha"
    },
    "change": {
      "title": "Change between the two dates",
      "sampleNote": "At least one of these dates has sample figures, so this change is illustrative.",
      "bars": "Gain or loss per class, in hectares",
      "class": "Class",
      "before": "Before (ha)",
      "after": "After (ha)",
      "deltaHa": "Change (ha)",
      "deltaPp": "Change (points)",
      "row": "{{name}}: {{delta}} ha"
    },
    "fullscreen": {
      "enter": "Full screen",
      "exit": "Leave full screen"
    }
  }
}
